import { LockOutlined, WarningOutlined } from "@ant-design/icons"
import { Select, type SelectProps } from "antd"
import { useCallback } from "react"

import { filterFormOptions } from "#utils/formHelpers"

type SessionOptionData = {
  disabled?: boolean
  hasConflict?: boolean
  hasWarning?: boolean
}

const SessionSelect = (props: SelectProps) => {
  const renderOption = useCallback(
    (option: { label?: React.ReactNode; data?: SessionOptionData }) => {
      if (option.data?.hasConflict) {
        return (
          <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <LockOutlined
              style={{ color: option.data?.disabled ? "#999" : "#faad14" }}
            />
            {option.label}
          </span>
        )
      }
      if (option.data?.hasWarning) {
        return (
          <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <WarningOutlined style={{ color: "#faad14" }} />
            {option.label}
          </span>
        )
      }
      return option.label
    },
    []
  )

  return (
    <Select
      showSearch
      filterOption={filterFormOptions}
      optionRender={renderOption}
      {...props}
    />
  )
}

export default SessionSelect
